// extracted by mini-css-extract-plugin
module.exports = {"languageSelector":"LanguageSelector_languageSelector__1zkYq","languageOptions":"LanguageSelector_languageOptions__ESHY-","icon":"LanguageSelector_icon__1LQcz"};